module.exports = __webpack_public_path__ + "static/img/bg_energy.8981e888.jpg";